import { Divider } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { isEmpty } from "../../lib/helpers/helpers";
import { useTransactionHistory } from "../../redux/api/Transaction";
import EmptyData from "../EmptyData/EmptyData";
import { Loading } from "../Loading/Loading";

const RightWrapper = styled.div`
	${tw`p-2 h-full bg-white w-full flex flex-col container`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}
`;

const HistoryWrapper = styled.div`
	${tw`flex flex-col mt-2 pb-4 hover:(bg-gray-50 cursor-pointer)`}
	border-bottom: 1px solid rgba(193, 202, 207, 0.2);
	/* @media (max-width: 1217px) {
		height: auto;
	} */
`;

const TransactionHistory = (props) => {
	const start = dayjs("1990-01-01").unix();
	const end = dayjs().add(1, "year").unix();
	// eslint-disable-next-line no-unused-vars
	const [type, setType] = useState("all");
	// eslint-disable-next-line no-unused-vars
	const [currencyCode, setCurrencyCode] = useState("NGN");

	const { data: historyData, isLoading: loadingHistory } =
		useTransactionHistory({ start, end, type, currencyCode });


	const Transactions = (props) => {
		return (
			<HistoryWrapper>
				<div
					css={{ color: "#94AFB6" }}
					tw="flex flex-row flex-nowrap items-center justify-between gap-1">
					<span tw="font-semibold text-sm md:text-base truncate">
						{props.transactionType}
						{/* Access Bank */}
					</span>
					<span tw="font-semibold text-xs md:text-sm whitespace-nowrap">
						{dayjs(props.time).format("hh:mm A")} {/* 02:03 PM */}
					</span>
				</div>
				<div tw="flex flex-row flex-wrap items-center justify-between">
					<span tw="font-semibold text-lg truncate">
						{props.purpose} {/* Ayodeji Osindele */}
					</span>
					<span
						tw="font-semibold text-base flex items-center justify-end"
						css={{
							color:
								props.transactionType === "credit"
									? "#41BE06"
									: props.transactionType === "debit"
									? "#F1573D"
									: "#C4C4C4",
						}}>
						{props.transactionType === "credit" ? "+" : "-"}₦
						{props.amount}
					</span>
				</div>
				<Divider tw="mt-1 mb-1" />
			</HistoryWrapper>
		);
	};
	return (
		<RightWrapper>
			<h3 tw="font-semibold tracking-wide text-sm md:text-lg">
				Transaction history
			</h3>

			<div>
				{loadingHistory ? (
					<div tw="flex items-center justify-center p-6">
						<Loading tw="text-appPinkSaturated" />
					</div>
				) : isEmpty(historyData?.data?.transactions) ? (
					<EmptyData />
				) : (
					historyData?.data?.transactions?.map((txns, i) => {
						return (
							<div key={i}>
								<Transactions
									transactionType={txns.transaction_type}
									time={txns.createdAt}
									purpose={txns.purpose}
									amount={txns.amount}
								/>
								{/* <div
									tw="mt-2 mb-4 pb-4"
									style={{
										borderBottom: "1px dashed #DDDDDD",
									}}>
									<Tag
										color="#C4C4C4"
										tw="text-appTextDark rounded-3xl text-sm font-semibold px-3 py-1 mb-4">
										15 July
									</Tag>
									<Transactions debit />
									<Transactions credit />
									<Transactions />
									<Transactions debit />
									<Transactions credit />
								</div> */}
								{/* <div tw="mt-2 mb-4 pb-4">
									<Tag
										color="#C4C4C4"
										tw="text-appTextDark rounded-3xl text-sm font-semibold px-3 py-1 mb-4">
										14 July
									</Tag>
									<Transactions debit />
									<Transactions credit />
								</div> */}
							</div>
						);
					})
				)}
			</div>
		</RightWrapper>
	);
};

export default TransactionHistory;
